/**
 * Palette for the public marketing pages, taken from the approved website
 * draft (`Website Drafts.dc.html`).
 *
 * Deliberately NOT the tailwind `turkis-*` tokens: the draft's brief rules out
 * turquoise on the website entirely — those tokens belong to the deck and the
 * logged-in product UI. The site runs on petrol, grey and the warm beiges.
 *
 * Two other rules from the same brief, worth repeating where they are easy to
 * break: never name a city in a headline or claim (DACH expansion is planned —
 * cities belong in filters and card metadata), and say "WGs", not "Häuser".
 */

/** Petrol. Headlines, buttons, dark bands. */
export const INK = "#092E2C";
/** Near-black petrol, reserved for the closing CTA band. */
export const INK_DEEP = "#06201F";
/** Body copy on light surfaces. */
export const MUTED = "#5E7371";
/** Labels and captions. */
export const MUTED_SOFT = "#6E7C7A";
/** The grey the draft uses for a headline's second, quieter line. */
export const GREY = "#9AAAA8";
/** Warm off-white page surface; sections alternate this with white. */
export const SAND = "#FAF8F4";
/** Hairline on cards and inputs. */
export const LINE = "#ECE7DD";
/** The softer hairline used inside a control (between pill segments). */
export const LINE_SOFT = "#EFEAE1";
/** Slightly stronger rule under a section header. */
export const LINE_STRONG = "#E4DCCE";
/** The bed a photo sits on while it loads. */
export const IMAGE_BG = "#EBE5DA";
/** Quiet chip fill (status pills, icon tiles). */
export const CHIP = "#E8EEEC";
/** Filled control surface inside a white pill (the city picker). */
export const FIELD = "#F4F1EB";

/** Shared easing for every entrance and hover in the marketing pages. */
export const EASE = [0.22, 1, 0.36, 1] as const;
